// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string, boolean } from "@altostra/type-validations/lib/primitives";

export const isCampaignOccurrencesResult = arrayOf(
  objectOf({
    time: string,
    name: string,
    id: string,
    type: string,
    enabled: boolean,
  })
);
